// ─────────────────────────────────────────
//  Gemensam statusmodell för en tRAT-session
// ─────────────────────────────────────────
// Tidigare hade Översikt, tRAT-listan, kursvyn och dashboarden fyra olika
// uppsättningar statusord, där samma ord kunde betyda olika saker ("Avslutad"
// betydde "har färdiga grupper" på ett ställe och "låst" på ett annat). All
// statuslogik och alla etiketter bor nu här.
//
// Prioritetsordning: ett lås slår allt, sedan faktisk gruppaktivitet (har
// grupper redan kört är tRAT:en inte längre "kommande"), sedan schemaläggning.

const SESSION_STATUSES = ["live", "done", "scheduled", "idle", "locked"];

function sessionStatus({ locked, availableAt, activeGroups = 0, doneGroups = 0 } = {}, now = Date.now()) {
  if (locked) return "locked";
  if (activeGroups > 0) return "live";
  if (doneGroups > 0) return "done";
  if (availableAt && new Date(availableAt).getTime() > now) return "scheduled";
  return "idle";
}

// label = singular (statusmärke på ett kort/en rad)
// labelPlural = för filterflikar och sektionsrubriker ("Avslutade")
// color = text-/kantfärg, dot = färg på statusprick
function statusMeta(status, lang, G) {
  const sv = lang === "sv";
  switch (status) {
    case "live":
      return { label: sv ? "Pågår" : "Live", labelPlural: sv ? "Pågående" : "Live", color: G.gold, dot: G.gold };
    // "Klar" = alla grupper har skrapat färdigt, men tRAT:en är fortfarande
    // öppen (appeals kan lämnas). "Avslutad" = läraren har stängt den.
    case "done":
      return { label: sv ? "Klar" : "Finished", labelPlural: sv ? "Klara" : "Finished", color: G.correct, dot: G.correct };
    case "scheduled":
      return { label: sv ? "Schemalagd" : "Scheduled", labelPlural: sv ? "Schemalagda" : "Scheduled", color: G.accent, dot: G.accent };
    case "locked":
      return { label: sv ? "Avslutad" : "Closed", labelPlural: sv ? "Avslutade" : "Closed", color: G.muted, dot: G.muted };
    default:
      return { label: sv ? "Ej startad" : "Not started", labelPlural: sv ? "Ej startade" : "Not started", color: G.muted, dot: G.border };
  }
}

export { SESSION_STATUSES, sessionStatus, statusMeta };
